import './styles.sass'

import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation, useParams } from 'react-router-dom'
import RouteData from '../../router/RouterData'
import arrowIcon from '../../assets/icons/arrow.svg'

interface IBreadcrumbs {
  paramsTitle?: any
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ paramsTitle }) => {
  const [Crumbs, setCrumbs] = useState<any>([])
  const location = useLocation()
  const params = useParams()

  const searchTitlePath: any = (dataSearch: any, path: string, link = '/admin') => {
    let title = null;
    for (let i = 0; i < dataSearch.length; i++) {
      if (dataSearch[i].path === path) {
        return {
          pathItem: dataSearch[i].path,
          title: dataSearch[i].title,
          link: `${link}/${dataSearch[i].path}`
        }
      }

      if (typeof dataSearch[i].children !== 'undefined') {
        const nextLink = `${link}/${dataSearch[i].path}`
        title = searchTitlePath(dataSearch[i].children, path, nextLink)
      }
    }

    return title;
  }

  useEffect(() => {
    let listPath = location.pathname
      .replace('/admin/', '')
      .replace('/admin', '')
      .split('/')

    if (Object.keys(params).length > 0) {
      Object.keys(params).map(itemParams => {
        listPath = listPath.map(item => {
          if (item === params[itemParams]) {
            return `:${itemParams}`
          } else {
            return item
          }
        })
      })
    }

    if (listPath.length > 0) {
      listPath = listPath.map(item => {
        return searchTitlePath(RouteData, item)
      })
    }

    if (typeof paramsTitle !== 'undefined' && Object.keys(paramsTitle).length > 0) {
      Object.keys(paramsTitle).map(item => {
        listPath = listPath.map((itemPathList: any) => {
          if (itemPathList.pathItem.replace(':', '') === item) {
            itemPathList.title = paramsTitle[item]
            itemPathList.link = itemPathList.link.replace(itemPathList.pathItem, paramsTitle[item])
          }
          return itemPathList
        })
      })
    }

    setCrumbs(listPath)
  }, [])


  return (
    <div className='breadcrumbs'>
      {Crumbs.map((item: any, index: number) => (
        <div key={`${index}${item.link}`}>
          {index !== Crumbs.length - 1 ? (
            <Link className='crumb' to={item.link}>
              {item.title}
              <span className="icon">
                <img src={arrowIcon} alt="next" />
              </span>
            </Link>
          ) : <span className="crumb active">{item.title}</span>
          }
        </div>
      ))}
    </div>
  )
}

export default Breadcrumbs
